import React from 'react';
export const ReconciledIcon = () => /*#__PURE__*/React.createElement("svg", {
  "data-testid": "qbo-reconciled",
  width: "24",
  height: "24",
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "9.5",
  cy: "9.5",
  r: "9.5",
  fill: "#529e36"
}), /*#__PURE__*/React.createElement("rect", {
  x: "6.07465",
  y: "8.0257",
  width: "5.70489",
  height: "3",
  transform: "rotate(43.7525 6.07465 8.0257)",
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: "8",
  y: "9.99667",
  width: "7.17846",
  height: "3",
  transform: "rotate(-44.112 8 9.99667)",
  fill: "white"
}));